import { CardTypes } from '@shared';

export interface Banner {
  title: string;
  text: string;
  visibleFor: CardTypes[] | [];
  // Overall visibility of the banner, independent of the card type
  disabled?: boolean;
  dateFrom?: string; // 'DD-MM-YYYY', like '01-12-2024'
  dateTo?: string; // 'DD-MM-YYYY', like '10-12-2024'
}

export const Banners: Banner[] = [
  {
    title: 'Простір експортера',
    text: '<strong>21 квітня у Львові, Park. Art of Rest, </strong>' + 'не пропустіть масштабну подію про e-commerce-експорт 2026. Встигніть забронювати свій квиток. Деталі за' +
      ' <a href="https://bit.ly/4bRMb0q" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '31-03-2026',
    dateTo: '20-04-2026',
  },
  {
    title: 'Отримайте -20% на рекламу у відділеннях',
    text: 'Розміщуйте рекламні ролики на відеопанелях у будь-яких з 1000 відділень Нової пошти. Мінімальна кількість відділень — від 50 шт. Акція діє з 23.02 по 23.04. Замовляйте розміщення за' +
      ' <a href="https://bit.ly/3ZKnNrZ" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '23-02-2026',
    dateTo: '23-04-2026',
  },
  {
    title: 'Фулфілмент повного циклу від Нової пошти',
    text: 'Друге дихання для вашого онлайн-бізнесу: зберігання товарів, пакування, миттєва відправка замовлень й опрацювання повернень, щоб у вас було більше часу на розвиток та продажі. ' +
      '<a href="https://novaposhta.ua/for-business/fulfillment/?utm_source=novaposhta_cabinet&utm_medium=cpc&utm_campaign=fulfillment_business" target="_blank">Підключити послугу →</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Принтер A3 для бізнесу та офісу',
    text:
      'Комплект картриджів на 47 000 сторінок у подарунок. Друкуй одразу без додаткових витрат. ' +
      'Деталі за' +
      ' <a href="https://shop-pm.com.ua/lexmark-cx950se-multifunctional-color-printer" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
    dateFrom: '27-04-2026',
    dateTo: '24-05-2026',
  },
  {
    title: 'Відкривайте пункт приймання-видачі Нової пошти',
    text: 'Запускаємо «під ключ», навчаємо персонал, надаємо технічну та маркетингову підтримку. ' +
      '<a href="https://form.typeform.com/to/muTWeJpz" target="_blank">Залишити заявку →</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Оплата відправлень в якості третьої особи',
    text: 'Вказуйте вашу компанію платником за інші відправлення з новим сервісом «Оплата третьою особою». ' +
      'Підключайте через персонального менеджера та користуйтеся. Деталі за' +
      ' <a href="https://novapost.com/uk-ua/financial-services/payment-of-shipments/payment-third-party/" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Хочете отримати нових клієнтів та більше замовлень?',
    text: 'Розміщуйте вашу рекламну пропозицію в наших каналах. Деталі за' +
      ' <a href="https://bit.ly/3CcdsNh" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Хочете продавати більше за конкурентів?',
    text: 'Оновіть списки відділень та поштоматів Нової Пошти, щоб охопити ще більше клієнтів. Не знаєте, як це зробити? Перейдіть за ' +
      '<a href="https://developers.novaposhta.ua/news/schodenne-onovlennya-dovidnika-viddilen-perekonaytes-scho-otrimuyete-aktualni-dani" target="_blank">посиланням</a>' +
      ', і ми вам допоможемо!',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Подовжуйте термін зберігання посилок',
    text: 'Термін зберігання у відділенні посилок з послугою «Автоматичне повернення відправлень» можна подовжувати. ' +
      'Деталі за' +
      ' <a href="https://novapost.com/uk-ua/additional-services/auto-return" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Безплатне переадресування посилок по Україні',
    text: 'Змінюйте місце й адресу доставки, поки відправлення ще не прибуло. Деталі' +
      ' <a href="https://novaposhta.ua/pereadresatsiya_im?utm_source=BK&utm_medium=Banner&utm_campaign=Pereadresatsiya" target="_blank">тут</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Послуга «Вантажні перевезення по Україні» – швидка та безпечна доставка ваших вантажів від 10 до 20 тонн окремим авто',
    text: 'Тепер з можливістю оплати готівкою. Деталі за' +
      ' <a href="https://novaposhta.ua/biznes_klientam/vantazhni_perevezennya/?utm_source=2b&utm_medium=referral&utm_campaign=npu_business" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Міжнародні фрахти для бізнесу',
    text: 'Швидко та безпечно доставимо ваш вантаж між країнами Європи та Україною. Вартість перевезення: від 1€/км. Залиште заявку за' +
      ' <a href="https://docs.google.com/forms/d/e/1FAIpQLSczezftcY9377yTNnfYkqSLpF3btk0yQMom2bm75aXq_d28YQ/viewform?usp=sf_link " target="_blank">посиланням</a>' + ', і ми надамо пропозицію спеціально для вашого бізнесу',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Пакуйте у себе, як на відділенні',
    text: 'Якісне пакування за оптовими цінами за' +
      ' <a href="https://shop.novaposhta.ua" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.ROZNIZA, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Хочете масштабувати свій бізнес? Навчайтесь у Школі бізнесу Нова пошта!',
    text: 'Отримайте практичні знання та розробіть план розвитку власного бізнесу. Деталі за' +
      ' <a href="https://novaposhta.education/"' +
      ' target="_blank">посиланням</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
  {
    title: 'Запропонуйте клієнтам Посилку в кредит',
    text: 'Продавайте в кредит будь-які товари з післяплатою, вартістю від 1000 грн. Деталі за' +
      ' <a href="https://novapay.ua/credit" target="_blank">посиланням</a>',
    visibleFor: [CardTypes.ROZNIZA, CardTypes.CCARD],
  },
  {
    title: 'Послуги для вашого бізнесу',
    text: 'Продавайте легко, а про складські операції, подбаємо ми. Цікаві умови?' +
      ' <a href="https://docs.google.com/forms/d/e/1FAIpQLSfTpCdJS9c70flQF4ujfdZw4bw93x_T6RHHlC8_CuN_61X37g/viewform?usp=sf_link"' +
      ' target="_blank">Заповніть анкету</a>',
    visibleFor: [CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE, CardTypes.ROZNIZA],
  },
  {
    title: 'Зауваження та пропозиції',
    text: 'Пропозиції щодо покращення роботи бізнес-кабінету надсилайте на' +
      ' <a href="mailto:support@novaposhta.ua">support@novaposhta.ua</a> або скористайтесь чатом з оператором',
    visibleFor: [CardTypes.ROZNIZA, CardTypes.CCARD, CardTypes.IDENTIFICATION, CardTypes.CORPORATE],
  },
];
